import { SupportedEntitlements } from '@core/models/entitlements';
import { getLicensingEntitlements } from '@hooks/queries/organization/licensing.utils';
import { useLicensing } from '@hooks/queries/organization/useLicensing';
import { useOrganization } from '@hooks/queries/useOrganization';
import { useImageryFlags } from '@hooks/useImageryFlags';
import { useWorkspaceId } from '@hooks/useWorkspaceId';

type DashboardAccessStatus = 'checking' | 'allowed' | 'denied' | 'error';

export function useDashboardAccess() {
  const organizationQuery = useOrganization();
  const { FlagShowIntelligenceDashboard } = useImageryFlags(organizationQuery.organization);
  const workspaceId = useWorkspaceId();
  const licensingQuery = useLicensing({
    account: workspaceId,
    enabled: Boolean(FlagShowIntelligenceDashboard),
  });

  let status: DashboardAccessStatus;
  if (!FlagShowIntelligenceDashboard) {
    status = 'denied';
  } else if ((!workspaceId && organizationQuery.isError) || licensingQuery.isError) {
    status = 'error';
  } else if (!workspaceId || !licensingQuery.data) {
    status = 'checking';
  } else {
    const entitlements = getLicensingEntitlements(
      licensingQuery.data,
      import.meta.env.VITE_APP_IMAGERY_APPID
    );
    status = entitlements.has(SupportedEntitlements.DISTRIBUTOR_DASHBOARD) ? 'allowed' : 'denied';
  }

  return {
    status,
    workspaceId,
    refetch: () => (workspaceId ? licensingQuery.refetch() : organizationQuery.refetch()),
  };
}
